import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_livetable');

register('wm-livetable', (): IBuildTaskDef => {
    return {
        pre: (attrs, shared: any) => {
          const counter = idGen.nextUid();
          shared.set('counter', counter);
          return `<${tagName} wmLivetable role="table" #${counter}="wmLivetable" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`,
        provide: (attrs, shared: any) => {
          const provider = new Map();
          provider.set('liveform_dialog_id', shared.get('counter'));
          return provider;
      }
    };
});

export default () => {};
